<hc-chip color="yellow" width="100%">
    <div class="cdp-warn-message-container">
        <hc-icon class="icon-warn" hcIconSm></hc-icon>
        <div>
            <span>Updating a legacy mode to Promoter v2.</span> Please add and run an Entity_Migration job to prepare
            the entity for loading prior to the next run.
        </div>
        <span class="icon-info cdp-info-ico" [hcTooltip]="tooltips.promoterTypeWarning"></span>
    </div>
</hc-chip>
